import React, { useEffect, useState } from "react";
import { Collapse } from "reactstrap";
import {
  Container,
  Row,
  Col,
  Card,
  CardTitle,
  CardText,
  Button,
  Input,
  Form,
  FormGroup,
  CardImg,
  InputGroup,
  Spinner,
} from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  useAccount,
  useContractRead,
  useContractWrite,
  // useNetwork,
} from "wagmi";
import {
  contractData,
  fromWeiToDecimals,
  toWeiToDecimals,
} from "../utils/web3-utils";
import { useLocation } from "react-router-dom";

export default function Dashboard() {
  const { address } = useAccount();
  const location = useLocation();
  // const urll = window.location.href;
  // console.log("header url", urll)
  const urll = window.location.href;
  const url = new URL(urll);
  const referralAddress = url.searchParams.get("ref");

  // console.log("header urll ",referralAddress);

  const { data: balance, loading } = useContractRead({
    abi: contractData?.astroflokiaiABI,
    address: contractData?.astroflokiaiAddress,
    functionName: "balanceOf",
    args: [address],
    watch: true,
  });

  const { data: investorData } = useContractRead({
    abi: contractData?.astroflokiaiStakingABI,
    address: contractData?.astroflokiaiStakingAddress,
    functionName: "investors",
    args: [address],
    select: (data) => ({
      user: data[0],
      totalStaked: fromWeiToDecimals(data[1]?.toString() || 0, 18),
      totalClaimed: fromWeiToDecimals(data[2]?.toString() || 0, 18),
      startDate: Number(data[3]) * 1000,
      referralCount: data[4]?.toString(),
      totalReferral: fromWeiToDecimals(data[5]?.toString() || 0, 18),
      referrer: data[6]?.toString(),
    }),
    watch: true,
  });

  const { data: totalReward } = useContractRead({
    abi: contractData?.astroflokiaiStakingABI,
    address: contractData?.astroflokiaiStakingAddress,
    functionName: "calculateTotalReward",
    args: [address],
    watch: true,
  });

  const [stakeValue, setStakeValue] = useState(5000000);
  const [packageData, setPackageData] = useState({
    min: 5000000,
    apy: 90,
    days: 90,
  });
  const [activeCard, setActiveCard] = useState(-1);
  const [stakeActive, setStakeActive] = useState(false);
  const [, setApproved] = useState(false);
  const [countdown, setCountdown] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const calculateCountdown = (endDate) => {
    const currentTime = new Date().getTime();
    const remainingTime = endDate - currentTime;

    if (remainingTime > 0) {
      const days = Math.floor(remainingTime / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (remainingTime % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (remainingTime % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

      setCountdown({ days, hours, minutes, seconds });
    } else {
      setCountdown({ days: 0, hours: 0, minutes: 0, seconds: 0 });
    }
  };

  useEffect(() => {
    if (stakeActive) {
      const endDate =
        investorData?.startDate + packageData.days * 24 * 60 * 60 * 1000;
      calculateCountdown(endDate);

      const countdownInterval = setInterval(() => {
        calculateCountdown(endDate);
      }, 1000);

      return () => clearInterval(countdownInterval);
    }
  }, [stakeActive, packageData.days, investorData?.startDate]);

  const handlePackageClick = (min, apy, days) => {
    setPackageData({ min, apy, days });
    setStakeValue(min);
    setActiveCard(min);
    setStakeActive(false);
  };

  const { data: allowance, refetch: refetchAllowance } = useContractRead({
    abi: contractData?.astroflokiaiABI,
    address: contractData?.astroflokiaiAddress,
    functionName: "allowance",
    args: [address, contractData?.astroflokiaiStakingAddress],
    watch: true,
  });

  const { writeAsync: approve, isLoading: isApproveLoading } = useContractWrite(
    {
      abi: contractData?.astroflokiaiABI,
      address: contractData?.astroflokiaiAddress,
      functionName: "approve",
      args: [
        contractData?.astroflokiaiStakingAddress,
        toWeiToDecimals(stakeValue, 18),
      ],
      onError(error) {
        console.log("Error", error);
      },
    }
  );

  const { writeAsync: stakeAmount, isLoading: isStakeLoading } =
    useContractWrite({
      abi: contractData?.astroflokiaiStakingABI,
      address: contractData?.astroflokiaiStakingAddress,
      functionName: "stakeAmount",
      args: [
        toWeiToDecimals(stakeValue, 18),
        referralAddress || "0x0000000000000000000000000000000000000000",
      ],
      value: toWeiToDecimals(0.01, 18),
      onError(error) {
        console.log("Error", error);
      },
    });

  const { writeAsync: claimReward, isLoading: isClaimRewardLoading } =
    useContractWrite({
      abi: contractData?.astroflokiaiStakingABI,
      address: contractData?.astroflokiaiStakingAddress,
      functionName: "claimTotalReward",
      args: [],
    });
  return (
    <Container id="dashboard">
      <p className="main-head"></p>
      <Row className="row1">
        <Col xs="12" md="12" lg="7" className="mb-5 second-container">
          <Card body className="card3 form ">
            {/* <Card> */}
            <Row className="">
              <Col xs="12">
                <h4>Pools</h4>
              </Col>
              <Col md="4">
                <Card
                  onClick={() => handlePackageClick(5000000, 90, 90)}
                  className={`package-card card-btn mb-2 mt-2 p-2 text-center ${
                    activeCard === 5000000 ? "active" : ""
                  }`}
                >
                  <CardTitle>POOL-1 (90 Days)</CardTitle>
                </Card>
                <Collapse isOpen={activeCard === 5000000}>
                  <Col className="text-white min-dep">
                    <div className="d-flex align-items-center justify-content-between">
                      <h6 className="mb-0"> Est.APY</h6>
                      <h6 className="mb-0 green"> 90%</h6>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                      <h6 className="mb-0"> Earning</h6>
                      <h6 className="mb-0 green"> 1% Daily</h6>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                      <h6 className="mb-0"> Minimum </h6>
                      <div className="d-flex align-items-end">
                        <h6 className="mb-0 green me-1"> $10</h6>
                        <small>(5Million AFLOKIAI)</small>
                      </div>
                    </div>
                    <Button
                      onClick={() => setStakeActive(true)}
                      className="primary button mt-2"
                      size="sm"
                    >
                      Stake Now
                    </Button>
                  </Col>
                </Collapse>
              </Col>
              <Col md="4" className="mt-3 mt-md-0">
                <Card
                  onClick={() => handlePackageClick(150000000, 168, 120)}
                  className={`package-card mb-2 mt-2 p-2 text-center ${
                    activeCard === 150000000 ? "active" : ""
                  }`}
                >
                  <CardTitle>POOL-2 (120 Days)</CardTitle>
                </Card>
                <Collapse isOpen={activeCard === 150000000}>
                  <Col className="text-white min-dep">
                    <div className="d-flex align-items-center justify-content-between">
                      <h6 className="mb-0"> APY</h6>
                      <h6 className="mb-0 green"> 168%</h6>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                      <h6 className="mb-0"> Earning</h6>
                      <h6 className="mb-0 green"> 1.4% Daily</h6>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                      <h6 className="mb-0"> Minimum </h6>
                      <div className="d-flex align-items-end">
                        <h6 className="mb-0 green me-1"> $3000</h6>
                        <small>(150,000,000 AFLOKIAI)</small>
                      </div>
                    </div>
                    <Button
                      onClick={() => setStakeActive(true)}
                      className="primary button mt-2"
                      size="sm"
                    >
                      Stake Now
                    </Button>
                  </Col>
                </Collapse>
              </Col>
              <Col md="4" className="mt-3 mt-md-0">
                <Card
                  onClick={() => handlePackageClick(300000000, 288, 180)}
                  className={`package-card mb-2 mt-2 p-2 text-center ${
                    activeCard === 300000000 ? "active" : ""
                  }`}
                >
                  <CardTitle>POOL-3 (180 Days)</CardTitle>
                </Card>
                <Collapse isOpen={activeCard === 300000000}>
                  <Col className="text-white min-dep">
                    <div className="d-flex align-items-center justify-content-between">
                      <h6 className="mb-0"> APY</h6>
                      <h6 className="mb-0 green">288%</h6>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                      <h6 className="mb-0"> Earning</h6>
                      <h6 className="mb-0 green"> 1.6% Daily</h6>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                      <h6 className="mb-0"> Minimum </h6>
                      <div>
                        <h6 className="mb-0 green me-1 text-nowrap">
                          {" "}
                          $10, 000
                        </h6>
                        <small>(300,000,000 AFLOKIAI)</small>
                      </div>
                    </div>
                    <Button
                      onClick={() => setStakeActive(true)}
                      className="primary button mt-2"
                      size="sm"
                    >
                      Stake Now
                    </Button>
                  </Col>
                </Collapse>
              </Col>
            </Row>
            {/* </Card> */}
            <Collapse isOpen={stakeActive}>
              <Form className="form">
                <FormGroup className="mt-5">
                  <Row>
                    <Col xs="8">Enter Amount</Col>
                    <Col>
                      Balance:{" "}
                      {!loading ? fromWeiToDecimals(balance || 0, 18) : "0"}{" "}
                      <span className="spn">AST</span>
                    </Col>
                  </Row>
                </FormGroup>
                <FormGroup className="mb-5">
                  <Row>
                    <Col>
                      <InputGroup className="inputGroup">
                        <Input
                          type="number"
                          placeholder={stakeValue}
                          value={stakeValue}
                          onChange={(e) => {
                            setStakeValue(e.target.value);
                            if (e?.target?.value < 150000000) {
                              setPackageData({
                                min: 5000000,
                                apy: 90,
                                days: 90,
                              });
                              setActiveCard(5000000);
                            } else if (e?.target?.value < 300000000) {
                              setPackageData({
                                min: 150000000,
                                apy: 180,
                                days: 120,
                              });
                              setActiveCard(150000000);
                            } else {
                              setPackageData({
                                min: 300000000,
                                apy: 288,
                                days: 180,
                              });
                              setActiveCard(300000000);
                            }
                          }}
                          className="custom-input"
                        />
                        <span className="input-group-text">AST</span>
                      </InputGroup>
                      <Col xs="12" className="green">
                        {packageData?.apy}% apy for {packageData?.days} days
                      </Col>
                    </Col>
                  </Row>
                </FormGroup>
                <Container className="text-center">
                  <FormGroup>
                    <Row>
                      <Col>
                        Total Token Staked :
                        <span className="spn">
                          {" "}
                          {investorData?.totalStaked} AST
                        </span>
                      </Col>
                    </Row>
                  </FormGroup>
                  <FormGroup className="mb-5">
                    <Row>
                      <Col>
                        <Button
                          color="primary"
                          className="button form-button approvebtn"
                          onClick={() => {
                            console.log(
                              allowance,
                              fromWeiToDecimals(allowance || 0, 18)
                            );
                            if (
                              fromWeiToDecimals(allowance || 0, 18) <
                              Number(stakeValue)
                            ) {
                              approve().then(() => {
                                refetchAllowance();
                                setApproved(true);
                              });
                            } else {
                              stakeAmount().then(() => {
                                setStakeValue(0);
                                setApproved(true);
                              });
                            }
                          }}
                          disabled={
                            stakeValue === "0" ||
                            stakeValue === "" ||
                            isStakeLoading ||
                            isApproveLoading ||
                            Number(stakeValue) >
                              Number(fromWeiToDecimals(balance || 0, 18)) ||
                            Number(stakeValue) < 5000000
                          }
                        >
                          {(isStakeLoading || isApproveLoading) && (
                            <Spinner size="sm" color="light" className="mr-2" />
                          )}
                          {fromWeiToDecimals(allowance || 0, 18) <
                          Number(stakeValue)
                            ? "Approve"
                            : "Stake"}
                        </Button>
                        <Button
                          className="button form-button my-3 refferalbtn"
                          disabled={!address}
                          onClick={() => {
                            navigator.clipboard.writeText(
                              `${
                                window?.location?.origin + location?.pathname
                              }?ref=${address}`
                            );
                            alert("Link copied");
                          }}
                        >
                          Copy Referral Link
                        </Button>
                        {address && (
                          <div>{`${
                            window?.location?.origin + location?.pathname
                          }?ref=${address}`}</div>
                        )}
                      </Col>
                    </Row>
                  </FormGroup>
                </Container>
              </Form>
            </Collapse>
            {stakeActive && (
              <Row className="countdown my-4 px-5">
                <Col>
                  Time remaining to Unstake:{" "}
                  <span className="spn">
                    {countdown.days} days, {countdown.hours} hours,{" "}
                    {countdown.minutes} minutes, {countdown.seconds} seconds
                  </span>
                </Col>
              </Row>
            )}
          </Card>
        </Col>

        <Col xs="12" md="12" lg="5" className="mb-5 ">
          <Collapse isOpen={true}>
            {/* <div className="scrollable-cards"> */}
            <Card body className="card1 mb-3 ">
              <Row>
                <Col xs="12">
                  <CardTitle tag="h5">Staking Rewards</CardTitle>
                </Col>
              </Row>
              <Row>
                <Col>
                  <CardImg />
                </Col>
              </Row>
              <CardText>
                <Row>
                  <Col className="cardHead">
                    {fromWeiToDecimals(totalReward?.toString() || 0, 18)}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Button
                      color="primary"
                      className="button claim-all-btn custom-button"
                      block
                      disabled={isClaimRewardLoading}
                      onClick={() => claimReward()}
                    >
                      {isClaimRewardLoading && (
                        <Spinner size="sm" color="light" />
                      )}
                      Claim All
                    </Button>
                  </Col>
                </Row>
              </CardText>
            </Card>
            <Card body className="card4">
              <Row>
                <Col xs="8">
                  <CardTitle tag="h5">Referral Count</CardTitle>
                </Col>
              </Row>
              <Row>
                <Col>
                  <CardImg />
                </Col>
              </Row>
              <CardText>
                <Row>
                  <Col className="cardHead">
                    {investorData ? investorData.referralCount ?? 0 : 0}
                  </Col>
                </Row>
              </CardText>
            </Card>
            <Card body className="card4">
              <Row>
                <Col xs="8">
                  <CardTitle tag="h5">Referral Rewards</CardTitle>
                </Col>
              </Row>
              <Row>
                <Col>
                  <CardImg />
                </Col>
              </Row>
              <CardText>
                <Row>
                  <Col className="cardHead">
                    {investorData ? investorData.totalReferral ?? 0 : 0}
                  </Col>
                </Row>
              </CardText>
            </Card>

            {/* <Card body className="card2 mb-5">
              <Row>
              <Col xs="8">
              <CardTitle tag="h5">You Stakes</CardTitle>
              </Col>
              <Col xs="4">
                  <Row>
                  <CardText>Stake Price:</CardText>
                  </Row>
                  <Row>
                  <Col>
                  <CardText className="text-right green">0.56%</CardText>
                  </Col>
                  <Col>
                  <CardImg src={vector2} height="14px" />
                  </Col>
                  </Row>{" "}
                  </Col>
                  </Row>
                  <Row>
                  <Col>
                  <CardImg />
                  </Col>
                  </Row>
              <CardText>
                <Row>
                  <Col className="cardHead">0.00</Col>
                  </Row>
                  <Row>
                  <Col xs="8" className="gray">
                  12% apy locked for 365 days And after 365 days 112% apy
                  </Col>
                  <Col xs="4">
                  <Button color="secondary">Withdraw</Button>
                  </Col>
                  </Row>
                  </CardText>
                  </Card>
                  
                  <Card body className="card1 mb-5">
                  <Row>
                  <Col xs="8">
                  <CardTitle tag="h5">Rewards</CardTitle>
                  </Col>
                  <Col xs="4">
                  <Row>
                    <CardText>Total Rewards:</CardText>
                    </Row>
                    <Row>
                    <Col>
                    <CardText className="text-right red">452542</CardText>
                    </Col>
                    <Col>
                    <CardImg src={vector1} height="14px" />
                    </Col>
                    </Row>
                    </Col>
                    </Row>
                    <Row>
                    <Col>
                    <CardImg />
                    </Col>
                    </Row>
                    <CardText>
                <Row>
                  <Col className="cardHead">0.00</Col>
                </Row>
                <Row>
                <Col xs="8" className="gray">
                    All your rewards will be shown here on this portal
                  </Col>
                  <Col xs="4">
                  <Button color="primary" className="button">
                  Claim All
                  </Button>
                  </Col>
                  </Row>
                  </CardText>
                  </Card>
                  
                  <Card body className="card2 mb-5">
                  <Row>
                  <Col xs="8">
                  <CardTitle tag="h5">You Stakes</CardTitle>
                  </Col>
                  <Col xs="4">
                  <Row>
                  <CardText>Stake Price:</CardText>
                  </Row>
                  <Row>
                  <Col>
                  <CardText className="text-right green">0.56%</CardText>
                  </Col>
                  <Col>
                      <CardImg src={vector2} height="14px" />
                      </Col>
                  </Row>{" "}
                  </Col>
              </Row>
              <Row>
                <Col>
                <CardImg />
                </Col>
                </Row>
                <CardText>
                <Row>
                <Col className="cardHead">0.00</Col>
                </Row>
                <Row>
                <Col xs="8" className="gray">
                12% apy locked for 365 days And after 365 days 112% apy
                </Col>
                  <Col xs="4">
                    <Button color="secondary">Withdraw</Button>
                  </Col>
                  </Row>
                  </CardText>
                </Card> */}
            {/* </div> */}
          </Collapse>
        </Col>
      </Row>
    </Container>
  );
}
